import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      try {
        // Get token from cookies
        const token = document.cookie
          .split("; ")
          .find((row) => row.startsWith("token="))
          ?.split("=")[1];

        if (!token) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        // Validate token with server
        const response = await fetch("https://preview.zushm.cz/api/auth/validate", {
          method: "GET",
          headers: {
            "Authorization": token,
          },
        });

        setIsAuthenticated(response.ok);
      } catch (error) {
        console.error("Token validation error:", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateToken();
  }, []);

  if (isLoading) {
    return <div>Checking access...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/adminlogin" replace />;
};

export default ProtectedRoute;